var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"gcao-calculator h-100 d-flex flex-column text-left",class:'gcao-calculator--' + _vm.calculatorName},[_c(_vm.calculatorComponent,{tag:"div",attrs:{"disclaimer":_vm.disclaimer,"note":_vm.note}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }